import { render, staticRenderFns } from "./diffWordPropertyLiability.vue?vue&type=template&id=308da92c&scoped=true"
import script from "./diffWordPropertyLiability.vue?vue&type=script&lang=js"
export * from "./diffWordPropertyLiability.vue?vue&type=script&lang=js"
import style0 from "./diffWordPropertyLiability.vue?vue&type=style&index=0&id=308da92c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308da92c",
  null
  
)

export default component.exports